import { UIRouter, Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { AuthResetPasswordComponent } from './resetPassword/resetPassword.component';
import { resolveStateParams } from '../global/resolves/params.resolve';
import { AuthProfileComponent } from './profile/profile.component';
import { resolveAuthenticated } from './resolves/authenticated.resolve';
import { resolveWaitForUser } from './resolves/waitForUser.resolve';

export let STATES: Ng2StateDeclaration[] = [
  {
    name: 'main.auth',
    abstract: true
  },
  {
    name: 'main.auth.profile',
    url: '/profil',
    views: {
      '$default@': {component: AuthProfileComponent}
    },
    params: {
      backgroundLight: true
    },
    resolve: [
      resolveWaitForUser,
      resolveAuthenticated,
      resolveStateParams
    ]
  },
  {
    name: 'main.auth.resetPassword',
    url: '/reset-password?c&e',
    views: {
      '$default@': {component: AuthResetPasswordComponent}
    },
    resolve: [
      resolveStateParams
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/auth/auth.states.ts